var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer-message"},[_vm._v("\n  "+_vm._s(_vm.title || '*本次会议为非公开会议，仅限于受邀请的特定人士参加。未经高毅资产书面同意，请勿对外转发或展示本邀请函，感谢您的理解与支持。')+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }